import { ChartVariantInternal } from '../types/timeseries.js';

/**
 * @param variant - The variant (or type) of the Chart, e.g. 'line', 'area', 'bar', etc.
 *
 * @returns true if the given ChartVariant supports a stacked visualization.
 */
export function isStacked(variant: ChartVariantInternal): boolean {
  return /^(area|bar)$/.test(variant);
}
